import { Text } from '@thefarmersfront/kitchen';

import styles from './DeliveryAreaRefineResult.module.scss';

type DeliveryAreaRefineResultInfoAreaProps = {
  description: string;
};

const DeliveryAreaRefineResultInfoArea = ({ description }: DeliveryAreaRefineResultInfoAreaProps) => {
  return (
    <div className={styles['result-message']}>
      <Text size="xxlarge" weight="semi-bold" color="primary">
        {description}
      </Text>
    </div>
  );
};

export { DeliveryAreaRefineResultInfoArea };
